// extracted by mini-css-extract-plugin
export default {"productBorder":"ProductList_productBorder__VJ-pU","productImage":"ProductList_productImage__tVc2D"};